<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import L from 'leaflet'
import propsBinder from 'vue2-leaflet/src/utils/propsBinder.js'
import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'

const props = {
  content: {
    default: ''
  },
  options: {
    type: Object,
    default: () => ({})
  },
  className: {
    type: String,
    custom: true,
    default: null
  }
}

export default {
  name: 'LTooltip',
  props: props,
  data () {
    return {
    }
  },
  methods: {
    setClassName (newVal, oldVal) {
      L.DomUtil.removeClass(this.mapObject._container, 'tooltip--selected')
      L.DomUtil.removeClass(this.mapObject._container, 'tooltip--prio1')
      L.DomUtil.removeClass(this.mapObject._container, 'tooltip--prio2')
      L.DomUtil.removeClass(this.mapObject._container, 'tooltip--filtered')

      if (newVal.includes('tooltip--selected')) {
        L.DomUtil.addClass(this.mapObject._container, 'tooltip--selected')
      }
      if (newVal.includes('tooltip--prio1')) {
        L.DomUtil.addClass(this.mapObject._container, 'tooltip--prio1')
      }
      if (newVal.includes('tooltip--prio2')) {
        L.DomUtil.addClass(this.mapObject._container, 'tooltip--prio2')
      }
      if (newVal.includes('tooltip--filtered')) {
        L.DomUtil.addClass(this.mapObject._container, 'tooltip--filtered')
      }
    }
  },
  mounted () {
    this.mapObject = L.tooltip(this.options)
    L.DomEvent.on(this.mapObject, this.$listeners)
    propsBinder(this, this.mapObject, props)
    this.mapObject.setContent(this.content || this.$el)
    this.parentContainer = findRealParent(this.$parent)
    this.parentContainer.mapObject.bindTooltip(this.mapObject)
  },
  beforeDestroy () {
    // if (this.parentContainer.mapObject.getTooltip()) {
    //   this.parentContainer.mapObject.unbindTooltip()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LTooltip.vue